import React, { useRef } from 'react';

import { Button, LinearProgress, Typography } from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

import { useValueChange } from 'hooks';

import styles from './Dialog.module.scss';

const ConfirmDialog = ({ open, onClose, title, message, busy, actions }) => {
  const text = useRef();
  const style = useRef();

  const content = useRef(null);

  useValueChange(open, () => {
    if (open) {
      style.current = undefined;
    }
  });

  useValueChange(busy, () => {
    if (busy && content.current) {
      style.current = {
        minWidth: content.current.offsetWidth,
        minHeight: content.current.offsetHeight,
      };
    }
  });

  if (open) {
    text.current = Array.isArray(message) ? message : [message];
  }

  return (
    <Dialog open={open} classes={{ paper: styles.dialog }}>
      <DialogTitle>{title || 'Confirmation'}</DialogTitle>

      <DialogContent ref={content} className={styles.content} style={style.current}>
        {(text.current || []).map((it, index) => (
          <Typography key={index} variant="body1" align="center">
            {it}
          </Typography>
        ))}

        {busy ? (
          <div className={styles.busy}>
            <LinearProgress />
          </div>
        ) : null}
      </DialogContent>

      <DialogActions>
        {!actions || actions === 'yesNo' ? (
          <>
            <Button
              onClick={() => onClose(false)}
              variant="contained"
              disabled={busy || !open}
            >
              no
            </Button>

            <Button
              onClick={() => onClose(true)}
              variant="contained"
              color="primary"
              disabled={busy || !open}
            >
              yes
            </Button>
          </>
        ) : (
          <Button
            onClick={() => onClose(false)}
            variant="contained"
            color="primary"
            disabled={busy || !open}
          >
            close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
